import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BrandHeroCarousel from 'components/commons/BrandHeroCarousel';
import './HomeLibreria.scss';

const ProductSection = ({ title, subtitle, products, renderItem, link }) => {
  if (!products?.length) return null;
  return (
    <section className="book67-section">
      <div className="book67-section__heading">
        <div><span>{'Una selecci\u00f3n para vos'}</span><h2>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
        {link && <Link to={link}>Ver todos <span aria-hidden="true">{'\u2192'}</span></Link>}
      </div>
      <div className="book67-products">{products.slice(0, 8).map((product) => <div key={product.id}>{renderItem(product)}</div>)}</div>
    </section>
  );
};

ProductSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.shape()),
  renderItem: PropTypes.func.isRequired,
  link: PropTypes.string,
};

const HomeLibreria = ({ sliders = [], categoriesHome = [], mostSelled = [], featuredProducts = [], offers = [], renderItem }) => {
  const categories = categoriesHome.filter((entry) => entry?.category?.name);

  return (
    <main className="book67-home">
      {sliders.length > 0 ? (
        <div className="book67-hero"><BrandHeroCarousel sliders={sliders} variant="libreria-regaleria" /></div>
      ) : null}
      {categories.length > 0 && (
        <section className="book67-section book67-categories">
          <div className="book67-section__heading"><div><span>{'Encontr\u00e1 tu pr\u00f3ximo favorito'}</span><h2>{'Explor\u00e1 por categor\u00eda'}</h2></div></div>
          <div className="book67-category-grid">
            {categories.slice(0, 6).map(({ category }) => (
              <Link className="book67-category" to={`/productos/${category.code || ''}`} key={category.id || category.code || category.name}>
                {category.imageHome || category.image ? <img src={category.imageHome || category.image} alt="" loading="lazy" /> : <div className="book67-category__placeholder" />}
                <span>{category.name}</span><b aria-hidden="true">{'\u2197'}</b>
              </Link>
            ))}
          </div>
        </section>
      )}

      <ProductSection title="Novedades" subtitle={'Reci\u00e9n llegados a la tienda.'} products={featuredProducts} renderItem={renderItem} link="/productos" />
      <ProductSection title={'Los m\u00e1s elegidos'} subtitle="Favoritos de nuestra comunidad." products={mostSelled} renderItem={renderItem} link="/masVendido" />
      <ProductSection title="Oportunidades especiales" subtitle={'Encontr\u00e1 algo \u00fanico a un precio especial.'} products={offers} renderItem={renderItem} link="/ofertas" />
    </main>
  );
};

HomeLibreria.propTypes = {
  sliders: PropTypes.arrayOf(PropTypes.shape()),
  categoriesHome: PropTypes.arrayOf(PropTypes.shape()),
  mostSelled: PropTypes.arrayOf(PropTypes.shape()),
  featuredProducts: PropTypes.arrayOf(PropTypes.shape()),
  offers: PropTypes.arrayOf(PropTypes.shape()),
  renderItem: PropTypes.func.isRequired,
};

export default HomeLibreria;



